import type { LangStrings } from './en';

export const de: LangStrings = {
  back: 'ZURÜCK',
  next: 'WEITER',
  retry: 'WIEDERHOLEN',
  replay: 'NOCHMAL',
  sector: 'SEKTOR',
  sectors: 'SEKTOREN',
  levels: 'LEVELS',
  cleared: 'GESCHAFFT',
  open: 'OFFEN',
  locked: 'GESPERRT',
  tba: 'TBA',
  slot_reserved: 'RESERVIERT',
  sfx_on: 'SFX AN',
  sfx_off: 'SFX AUS',
  reset_progress: 'FORTSCHRITT LÖSCHEN',
  wiped_reloading: 'GELÖSCHT, LÄDT NEU…',
  got_it: '› VERSTANDEN ‹',

  boot_eyebrow: 'KASKADE-PROTOKOLL  //  BUILD',
  boot_tagline: 'EIN TIPP. EINE KASKADE. KEIN RESET.',
  boot_subtitle: '信号崩壊  ·  KASKADENLOGIK',
  boot_cta: '› TIPPEN ZUM START ‹',
  boot_region: 'REGION ▣ /7',
  boot_top_left: 'HAYTERWAVE//SYSCORE',
  boot_top_right_status: '0xC7A5 // ONLINE',

  menu_header_subtitle: 'NØDUS / SEKTOR.AUSWAHL',
  menu_engine_label: 'signal-kollaps-motor',
  menu_signals_down: 'signale gefallen',
  menu_tap_chapter: 'TIPPE EIN KAPITEL ZUM ÖFFNEN',
  menu_language_label: 'SPRACHE',

  chapter_signals_down: 'signale gefallen',
  chapter_tba_label: '0xTBA',
  chapter_coda_name: 'CODA',
  chapter_coda_tagline: 'Nichts Neues. Alles kombiniert.',

  hud_tap_to_breach: '▾  einen knoten antippen zum durchbruch  ▾',
  hud_tap_to_skip: "überspringen  ▸▸",
  hud_drag_zoom_help: 'ziehen zum schwenken · rad/pinch zum zoomen',
  hud_required: 'ERFORDERLICH',
  hud_core_online: 'KERN AKTIV',
  hud_core_down: 'KERN GEFALLEN',

  tut_tap_any_node: 'BELIEBIGEN KNOTEN TIPPEN',
  tut_they_all_work: 'hier funktionieren alle',

  brief_eyebrow: '◂ MISSION ▸',
  brief_title: 'EIN TIPP.\nEINE KASKADE.',
  brief_line_1: '› Du hast genau EINEN Tipp.',
  brief_line_2: '› Er löst eine Kettenreaktion im Netzwerk aus.',
  brief_line_3: '› Lass jeden ERFORDERLICHEN (cyan Raute) kollabieren um zu gewinnen.',
  brief_line_4: '› Lass nie einen Impuls einen GESCHÜTZTEN (rot) berühren.',
  brief_begin: '› MISSION STARTEN ‹',

  result_win_headline: 'SYSTEM KOLLABIERT',
  result_fail_headline: 'KASKADE FEHLGESCHLAGEN',
  result_first_clear: '› ERSTER ERFOLG ‹',
  result_try_label: '› VERSUCH',
  result_cleared_suffix: 'GESCHAFFT',
  result_aborted_suffix: 'LAUF ABGEBROCHEN',
  result_win_body_template: '{ticks} Ticks. {nodes} Knoten gefallen.',

  fail_protected_overload: 'Geschützter Knoten überlastet. Die Kaskade hat etwas getroffen, das sie nicht durfte.',
  fail_forbidden_trigger: 'Eine verbotene Leitung führte ein Signal. Harter Alarm ausgelöst.',
  fail_required_not_reached: 'Ein erforderlicher Knoten erhielt nie einen Impuls. Die Kette erreichte ihn nicht.',
  fail_required_under_threshold: 'Ein erforderlicher Knoten erhielt nicht genug Impulse. Der erste verfiel vor dem zweiten.',
  fail_core_not_collapsed: 'Der Kern überlebte. Die Kaskade verpuffte vor ihm.',
  fail_core_under_threshold: 'Der Kern erhielt Impulse, aber nicht genug, sie konvergierten nicht rechtzeitig.',
  fail_core_shielded: 'Kernimpulse blockiert. Ein Schild war noch aktiv.',
  fail_chain_died: 'Die Kette starb, bevor sie irgendetwas erreichte.',
  fix_protected_overload: 'Wähle einen Starter, dessen Kaskade nie die rote Gefahr erreicht. Zeichne zuerst die Abgänge nach.',
  fix_forbidden_trigger: 'Vermeide Starter, die IN ein rotes gestricheltes Kabel feuern. Der Alarm springt sofort an.',
  fix_required_not_reached: 'Dein Starter ist nicht mit diesem Knoten verbunden. Sieh dir die Pfeile an, gerichtete Kabel fließen nur in eine Richtung.',
  fix_required_under_threshold: 'Finde eine Route mit zwei Impulsen zu diesem Knoten, ein Teiler oder zwei konvergente Pfade reichen meist.',
  fix_core_not_collapsed: 'Du brauchst mehr Konvergenz zum Kern. Teiler, Kondensatoren und Relais sind dafür da.',
  fix_core_under_threshold: 'Impulse kommen zu langsam an. Nutze Teiler um Treffer zu stapeln, oder lass alle im selben Tick landen.',
  fix_core_shielded: 'Werfe jeden Schild ab, bevor ein tödlicher Treffer landet. Ein verspätetes Verzögerungskabel ist sauber.',
  fix_chain_died: 'Dein Starter verbindet sich nur mit einem Knoten. Wähle einen in der Netzmitte.',

  popup_new_node: '◂ NEUER KNOTENTYP ▸',
  popup_new_wire: '◂ NEUER KABELTYP ▸',

  node_normal_title: 'KNOTEN',
  node_normal_tagline: 'Die Grundeinheit. Tippen um eine Kaskade zu starten.',
  node_normal_b1: 'Kollabiert beim ersten ankommenden Impuls.',
  node_normal_b2: 'Feuert einen Impuls auf jedes offene ausgehende Kabel.',
  node_normal_b3: 'Kein Schwellwert, ein Treffer und er ist weg.',

  node_required_title: 'ERFORDERLICH',
  node_required_tagline: 'Du musst jeden ERFORDERLICHEN kollabieren um zu gewinnen.',
  node_required_b1: 'Cyan Raute. Pulsiert leise im Leerlauf damit du sie siehst.',
  node_required_b2: 'Manche brauchen 2+ Impulse im selben Zeitfenster.',
  node_required_b3: 'Verfehl auch nur einen und der Lauf endet.',
  node_required_note: 'Ein kleiner Punkteringe zeigt seinen Ladefortschritt.',

  node_protected_title: 'GESCHÜTZT',
  node_protected_tagline: 'Berühr ihn und der ganze Lauf stirbt.',
  node_protected_b1: 'Rotes Gefahrenkreuz. Markiert mit Eckwinkeln.',
  node_protected_b2: 'Jeder Impuls darauf = sofortiger FEHLSCHLAG.',
  node_protected_b3: 'Plane eine Route, die ihn nie füttert.',

  node_relay_title: 'RELAIS',
  node_relay_tagline: 'Öffnet gesperrte Kabel beim Kollaps.',
  node_relay_b1: 'Goldener Chevron. Ziele sind GESTRICHELTE GESPERRTE Kabel.',
  node_relay_b2: 'Wenn das Relais fällt, leuchten seine gesperrten Kabel auf.',
  node_relay_b3: 'Nützlich um einen Weg zu einem bewachten Knoten freizulegen.',

  node_shield_title: 'SCHILD',
  node_shield_tagline: 'Ein Leibwächter. Absorbiert Treffer für einen anderen Knoten.',
  node_shield_b1: 'Grüner Hexagon-Ring um den geschützten Knoten.',
  node_shield_b2: 'Ein direkter Impuls auf einen geschilderten Knoten BEWIRKT NICHTS.',
  node_shield_b3: 'Lass zuerst den Schild fallen, dann liefere den finalen Schuss.',
  node_shield_note: 'VERZÖGERUNGS-Kabel (gold gestrichelt) sind perfekt für einen Schuss nach Schildabwurf.',

  node_splitter_title: 'TEILER',
  node_splitter_tagline: 'Multipliziert Impulse auf allen Ausgängen.',
  node_splitter_b1: 'Magenta-Gabel. Ein Impuls rein → N Impulse pro Ausgang.',
  node_splitter_b2: 'Die X-Markierung zeigt seinen Teilungsfaktor.',
  node_splitter_b3: 'Liefert die Mehrfachtreffer die ein KERN mit hohem Schwellwert braucht.',

  node_capacitor_title: 'KONDENSATOR',
  node_capacitor_tagline: 'Speichert einen Impuls, sendet ihn erneut, ein Puffer.',
  node_capacitor_b1: 'Gelbes Kondensatorsymbol. Leitet einen Impuls 3 Ticks später weiter.',
  node_capacitor_b2: 'Behandle ihn wie eine eingebaute VERZÖGERUNG in der Route.',
  node_capacitor_b3: 'Erlaubt einem späteren Impuls NACH einem Schildabwurf anzukommen.',

  node_core_title: 'KERN',
  node_core_tagline: 'Das Ziel. Hoher Schwellwert, schneller Zerfall.',
  node_core_b1: 'Lila Reaktor. Braucht viele konvergente Impulse zum Fallen.',
  node_core_b2: 'Die Ladung ZERFÄLLT, Impulse müssen dicht beieinander ankommen.',
  node_core_b3: 'Oft schildgeschützt. Schilde fallen lassen, dann den Kern fluten.',
  node_core_note: 'Ein Level mit KERN wird durch dessen Kollaps gewonnen. Erforderliche Knoten (falls vorhanden) zählen auch.',

  wire_directional_title: 'GERICHTETES KABEL',
  wire_directional_tagline: 'Einbahnleiter. Cyan mit Pfeilspitze.',
  wire_directional_b1: 'Impuls wandert nur in Pfeilrichtung.',
  wire_directional_b2: 'Tippe auf die falsche Seite des Pfeils und nichts fließt.',
  wire_directional_b3: 'Folge den Pfeilen vom Starter bis ganz nach unten.',

  wire_delay_title: 'VERZÖGERUNGSKABEL',
  wire_delay_tagline: 'Gold gestrichelt. Der Impuls kommt 3 Ticks später an.',
  wire_delay_b1: 'Nützlich zum Timing, lande einen Impuls NACH einem Schildabwurf.',
  wire_delay_b2: 'Oder um zwei Impulse auf einem Knoten mit hohem Schwellwert zu stapeln.',
  wire_delay_b3: 'Verfehle das Timing und der erste Impuls zerfällt zuerst.',

  wire_locked_title: 'GESPERRTES KABEL',
  wire_locked_tagline: 'Grau gestrichelt + Schloss. Geschlossen bis etwas es öffnet.',
  wire_locked_b1: 'Ein RELAIS kontrolliert jedes gesperrte Kabel.',
  wire_locked_b2: 'Wenn das Relais kollabiert, schnappen seine gesperrten Kabel auf.',
  wire_locked_b3: 'Verschwende keinen Tipp damit, ein gesperrtes Kabel direkt zu füttern.',

  wire_forbidden_title: 'VERBOTENES KABEL',
  wire_forbidden_tagline: 'ROT gestrichelt mit Kreuz. Berühren = sofortiger Fehlschlag.',
  wire_forbidden_b1: 'Jeder Impuls, auch ein Durchgangsimpuls, löst den Alarm aus.',
  wire_forbidden_b2: 'Achte auf diese auf den Abgängen jedes Starters.',
  wire_forbidden_b3: 'Wähle einen Starter dessen Route NIEMALS rot berührt.',

  wire_burn_title: 'BRENNKABEL',
  wire_burn_tagline: 'Messing-orange. Einmal-Leiter, verbrennt nach einem Impuls.',
  wire_burn_b1: 'Trägt genau EINEN Impuls, dann stirbt es für immer.',
  wire_burn_b2: 'Plane seine einzige Nutzung sorgfältig, keine zweite Chance.',
  wire_burn_b3: 'Einmal verbrannt kann keine Kaskade es mehr nutzen.',

  callout_required_crashed: 'ERFORDERLICH GEFALLEN',
  callout_core_breached: 'KERN DURCHBROCHEN',
  callout_shield_dropped: 'SCHILD GEFALLEN',
  callout_relay_opened: 'RELAIS GEÖFFNET',
  callout_protected_hit: 'GESCHÜTZT GETROFFEN',

  // ── Beta: settings ─────────────────────────────────────────
  menu_settings: 'SETTINGS',
  settings_title: 'SETTINGS',
  settings_sound: 'Sound',
  settings_haptics: 'Haptics',
  settings_haptics_note: 'device only',
  settings_on: 'ON',
  settings_off: 'OFF',
  settings_replay_tutorials: 'Replay tutorials',
  settings_reset_progress: 'Reset all progress',
  settings_reset_confirm: 'TAP AGAIN TO WIPE',
  settings_done: 'DONE',

  // ── Beta: achievements / share ─────────────────────────────
  menu_achievements: 'AWARDS',
  ach_title: 'ACHIEVEMENTS',
  ach_new: 'ACHIEVEMENT UNLOCKED',
  ach_locked: 'LOCKED',
  share_button: 'SHARE',
  share_copied: 'Copied to clipboard',

  // ── Beta: daily challenge ──────────────────────────────────
  daily_title: 'DAILY',
  daily_tagline: 'One fresh puzzle every day. Keep the streak alive.',
  daily_new: 'NEW TODAY',
  daily_keep: 'KEEP IT ALIVE',
  menu_play_first: 'LEVEL 1 FIRST',
  daily_done: 'SOLVED ✓',
  daily_solved: 'DAILY SOLVED',
  daily_streak: 'STREAK',

  // ── Beta: ads / lives / hints / stats ───────────────────────
  ad_label: 'ADVERTISEMENT',
  ad_house_tagline: 'One tap. One breach. Infinite levels.',
  ad_rewarded_watching: 'Watch to earn your reward',
  ad_interstitial_watching: 'Your run continues in a moment',
  ad_rewarded_done: 'Reward unlocked',
  ad_interstitial_done: 'Thanks for playing',
  ad_reward_in: 'Reward in {n}s',
  ad_claim: 'CLAIM',
  ad_continue: 'CONTINUE',
  lives_label: 'LIVES',
  run_over_headline: 'OUT OF LIVES',
  run_over_body: 'Your run is on the line. Watch an ad for a life, or bank this run.',
  watch_for_life: 'AD  +1 LIFE',
  bank_run: 'BANK RUN',
  life_lost: '-1 LIFE',
  hint_button: 'HINT',
  hint_confirm_title: 'WATCH AD FOR A HINT?',
  hint_confirm_body: 'Rules out one breach point that does NOT solve this level. It never shows you the answer.',
  hint_yes: 'WATCH AD',
  hint_removed: 'One wrong breach point ruled out',
  hint_none_left: 'Nothing left to rule out',
  no_thanks: 'NO THANKS',
  stats_title: 'STATISTICS',
  menu_stats: 'STATS',
  stats_levels_completed: 'Levels completed',
  stats_endless_best: 'Endless best',
  stats_best_streak: 'Best streak',
  stats_fail_rate: 'Fail rate',
  stats_wins: 'Wins',
  stats_fails: 'Fails',
  stats_hints_used: 'Hints used',
  stats_ads_watched: 'Ads watched',
  stats_close: 'CLOSE',
  // ── Added with the redesign (machine draft, see TRANSLATIONS-DRAFT.md) ──
  result_map_tapped: 'Dein Tipp',
  result_map_broke: 'Hier gescheitert',
  result_map_answer: 'Funktioniert',
  result_show_answer: 'Lösung zeigen',
  menu_endless_line: 'Generierte Level mit drei Leben. Je tiefer du kommst, desto härter wird es.',
  menu_best: 'Beste LV {n}',
  menu_best_streak: 'Beste LV {n}  ·  Serie ×{s}',
  menu_resume: 'Weiter LV {n}',
  menu_start: 'Start LV 1',
  result_run_total: 'Gesamt dieses Laufs {n}',
  result_streak: 'Serie ×{n}',
  result_streak_wins: '{n} Siege in Folge',
  legend_title: 'Legende',
  legend_nodes: 'KNOTEN',
  legend_wires: 'LEITUNGEN',
  legend_close: 'Zum Schließen irgendwo tippen',
  settings_sync_now: 'Jetzt sync ({who})',
  settings_sign_in: 'Zum Sync anmelden',
  settings_sign_out: 'Abmelden',

};
